import React, {Component} from 'react'
import SelectSegments from './../../../components/Select/Books/SelectSegments'

class FilterAdoptions extends Component {
  mapSelectOptions = (type) => {
    return type.items.map((item) => {
      return {label: item.name, value: item.id}
    })
  }

  clearFitler = () => {
    this.subjectSelect.resetValue()
    this.teacherSelect.resetValue()
  }

  render () {
    const {
      subjects,
      teachers,
      disabled,
      checkUnit,
      changeFilter
    } = this.props
    return (
      <div className='select-filter__wrapper' onClick={checkUnit}>
        <span className='select-filter__label'>Disciplinas: </span>
        {subjects.items.length > 0 && (
          <SelectSegments
            options={this.mapSelectOptions(subjects)}
            isLoading={subjects.isFetching}
            placeholder='Selecione a(s) disciplina(s)'
            changeFilter={changeFilter}
            type='subjects'
            multi
            clearable
            searchable
            minWidth={'220px'}
            disabled={disabled}
            ref={(element) => { this.subjectSelect = element }}
          />
        )
        }
        <span className='select-filter__label'>Professor: </span>
        {subjects.items.length > 0 && (
          <SelectSegments
            options={this.mapSelectOptions(teachers)}
            isLoading={teachers.isFetching}
            placeholder='Pesquise pelo nome'
            changeFilter={changeFilter}
            type='teachers'
            multi
            clearable
            searchable
            minWidth={'250px'}
            ref={(element) => { this.teacherSelect = element }}
            disabled={disabled}
          />
        )
        }
      </div>
    )
  }
}

export default FilterAdoptions



// WEBPACK FOOTER //
// ./src/components/Filter/FilterAdoptions/index.js